import React from "react";
import "./styles/styles.css";
import "../../styles/global.css";

const Loader = () => {
  return (
    <div className="flex-direction-row gap-12 width-100 justify-center items-center loader-dots-container">
      <div className="dot dot1"></div>
      <div className="dot dot2"></div>
      <div className="dot dot3"></div>
    </div>
  );
};

export default Loader;
